import items from './items';

const root = {
	items
};

export default root;
